import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const WFHDApi = createApi({
  reducerPath: "WFHDApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start WFHD Dashbord API's---------------------------
    getAllWfhdExitUser: builder.query({
      query: () => "get_all_history_data",
      transformResponse: (response) => response?.data,
    }),
    getWfhdUserwithDept: builder.query({
      query: () => "get_wfh_users_with_dept",
      transformResponse: (response) => response?.data,
    }),
    getBirthdayWFHD: builder.query({
      query: () => "get_birth_days",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getWorkAniversaryWFHD: builder.query({
      query: () => "get_work_anniversary",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getExitofWFHD: builder.query({
      query: () => "get_exit_of_wfhd_users",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getAllExitWFHDUser: builder.query({
      query: () => "get_all_exit_users_of_wfhd",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getNewJoineeWFHD: builder.query({
      query: () => "get_newjoinee_of_wfhd_users",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getAllWFHDUsers: builder.query({
      query: () => "get_all_wfh_users",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getSalaryByLPAWFHD: builder.query({
      query: () => "get_salary_by_LPA",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getSalaryByMonthWFHD: builder.query({
      query: () => "get_salary_by_month_wise",
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 60 * 60 * 24,
    }),
    getWfhFinanceData: builder.query({
      query: () => "get_finances",
      transformResponse: (response) => response?.data,
    }),

    getAllUserwithJoiningDate: builder.query({
      query: (params) => {
        const payload = new URLSearchParams();
        if (params?.month) payload.append("month", params.month);
        if (params?.year) payload.append("year", params.year);
        if (params?.deptId) payload.append("dept_id", params.deptId);

        return `get_all_users_counts_with_joining_date${
          payload.toString() ? `?${payload.toString()}` : ""
        }`;
      },
      transformResponse: (response) => response?.data || [],
      keepUnusedDataFor: 0,
    }),

    editReportL1Change: builder.mutation({
      query: (updateGroup) => ({
        url: `change_all_reportL1_by_sub_dept`,
        method: "PUT",
        body: updateGroup,
      }),
    }),
    editTrainingData: builder.mutation({
      query: (edit) => ({
        url: `update_training`,
        method: "PUT",
        body: edit,
      }),
    }),

    addTrainingData: builder.mutation({
      query: (addGroup) => ({
        url: "add_user_training",
        method: "POST",
        body: addGroup,
      }),
    }),

    addSepration: builder.mutation({
      query: (addgen) => ({
        url: "add_separation",
        method: "POST",
        body: addgen,
      }),
    }),

    getAllWfhdDepartment: builder.query({
      query: () => "all_departments_of_wfh",
      transformResponse: (response) => response?.data,
    }),

    getWfhdJoiningSummary: builder.query({
      query: (id) => `user_wfhd_joining_summary/${id}`,
      transformResponse: (response) => response?.data,
    }),

    getGraphDataWFHD: builder.query({
      query: ({ caseType }) => {
        let url = `get_user_graph_data_of_wfhd`;
        if (caseType) url += `?caseType=${encodeURIComponent(caseType)}`;
        return url;
      },
      transformResponse: (response) => response?.data,
    }),

    getWfhdFinanceData: builder.query({
      query: () => "get_finances",
      transformResponse: (response) => response?.data,
    }),

    editFinance: builder.mutation({
      query: (edit) => ({
        url: "edit_finance",
        method: "PUT",
        body: edit,
      }),
    }),

    updateFinance: builder.mutation({
      query: (update) => ({
        url: "update_finance_data",
        method: "PUT",
        body: update,
      }),
    }),

    getWfhdTdsUsers: builder.query({
      query: (params) => {
        const payload = new URLSearchParams();
        if (params?.month) payload.append("month", params.month);
        if (params?.year) payload.append("year", params.year);
        if (params?.deptId) payload.append("dept_id", params.deptId);
        return `get_wfhd_tds_users${
          payload.toString() ? `?${payload.toString()}` : ""
        }`;
      },
      transformResponse: (response) => response?.data || [],
    }),

    editUtr: builder.mutation({
      query: (edit) => ({
        url: "edit_finance_utr",
        method: "PUT",
        body: edit,
      }),
    }),
    setUtrData: builder.mutation({
      query: (data) => ({
        url: "set_utr_data",
        method: "POST",
        body: data,
      }),
    }),

    getWfhdDoc: builder.query({
      query: (id) => ({
        url: "get_wfhd_user_doc",
        params: { user_id: id }, // this will add ?user_id=123 in URL
      }),
      transformResponse: (response) => response?.data,
    }),

    getWfhdBonusData: builder.query({
      query: () => "get_all_wfhd_users_with_bonus",
      transformResponse: (response) => response?.data,
    }),

    getSalaryWithCalculationFilter: builder.query({
      query: (filterOption) => ({
        url: "get_salary_calculation_with_filter_data",
        params: { filterOption },
      }),
      transformResponse: (response) => response?.data,
    }),
    getWfhdBillingHeader: builder.query({
      query: () => "get_all_billingheaders",
      transformResponse: (response) => response?.data,
    }),

    getWfhdSheetData: builder.query({
      query: () => "get_sheet_data",
      transformResponse: (response) => response?.data,
    }),
  }),
});

export const {
  useAddGroupMutation,

  useGetAllWfhdExitUserQuery,
  useGetWfhdUserwithDeptQuery,
  useGetBirthdayWFHDQuery,
  useGetWorkAniversaryWFHDQuery,
  useGetExitofWFHDQuery,
  useGetAllExitWFHDUserQuery,
  useGetNewJoineeWFHDQuery,
  useGetAllWFHDUsersQuery,
  useGetSalaryByLPAWFHDQuery,
  useGetSalaryByMonthWFHDQuery,
  useGetAllUserwithJoiningDateQuery,

  useGetWfhFinanceDataQuery,
  useGetWfhdJoiningSummaryQuery,

  useEditReportL1ChangeMutation,
  useAddTrainingDataMutation,
  useEditTrainingDataMutation,
  useAddSeprationMutation,

  useGetAllWfhdDepartmentQuery,

  useGetGraphDataWFHDQuery,

  // Finance API's
  useGetWfhdFinanceDataQuery,
  useEditFinanceMutation,
  useUpdateFinanceMutation,
  useGetWfhdTdsUsersQuery,
  useEditUtrMutation,
  useSetUtrDataMutation,
  useGetWfhdDocQuery,
  useGetWfhdBonusDataQuery,
  useGetSalaryWithCalculationFilterQuery,

  useGetWfhdBillingHeaderQuery,

  useGetWfhdSheetDataQuery,
} = WFHDApi;

export default WFHDApi;
